import Plans from 'src/security/plans';
import Roles from 'src/security/roles';
import Storage from 'src/security/storage';

const storage = Storage.values;
const roles = Roles.values;
const plans = Plans.values;

class Permissions {
  static get values() {
    return {
      dashboardOperational: {
        id: 'dashboardOperational',
        allowedRoles: [
          // roles.sub_admin,
          // roles.admin,
          // roles.supervisor,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      tenantEdit: {
        id: 'tenantEdit',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      tenantRead: {
        id: 'tenantRead',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      tenantCreate: {
        id: 'tenantCreate',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      tenantDestroy: {
        id: 'tenantDestroy',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      planEdit: {
        id: 'planEdit',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      planRead: {
        id: 'planRead',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userEdit: {
        id: 'userEdit',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userDestroy: {
        id: 'userDestroy',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userCreate: {
        id: 'userCreate',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userImport: {
        id: 'userImport',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userRead: {
        id: 'userRead',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userAutocomplete: {
        id: 'userAutocomplete',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      auditLogRead: {
        id: 'auditLogRead',
        allowedRoles: [
          roles.sub_admin,
          roles.admin,
          roles.supervisor,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      settingsEdit: {
        id: 'settingsEdit',
        allowedRoles: [
          roles.sub_admin,
          roles.admin,
          roles.supervisor,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.settingsBackgroundImages,
          storage.settingsLogos,
        ],
      },
      locationImport: {
        id: 'locationImport',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      locationCreate: {
        id: 'locationCreate',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.locationAvatar],
      },
      locationEdit: {
        id: 'locationEdit',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.locationAvatar],
      },
      locationDestroy: {
        id: 'locationDestroy',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.locationAvatar],
      },
      locationTemplateManage: {
        id: 'locationTemplateManage',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      locationRead: {
        id: 'locationRead',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      locationAutocomplete: {
        id: 'locationAutocomplete',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      resourceImport: {
        id: 'resourceImport',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      resourceCreate: {
        id: 'resourceCreate',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.resourceIcon,
          storage.resourceStartPagePhoto,
          storage.resourceClosureEvidencePhoto,
          storage.resourceConditionPhotos,
          storage.resourceInstructionsPhoto,
        ],
      },
      resourceEdit: {
        id: 'resourceEdit',
        allowedRoles: [
          // roles.supervisor,
          // roles.sub_admin,
          roles.admin,
          roles.supervisor,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.resourceIcon,
          storage.resourceStartPagePhoto,
          storage.resourceClosureEvidencePhoto,
          storage.resourceConditionPhotos,
          storage.resourceInstructionsPhoto,
        ],
      },
      resourceDestroy: {
        id: 'resourceDestroy',
        allowedRoles: [
          roles.sub_admin,
          roles.admin,
          roles.supervisor,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.resourceIcon,
          storage.resourceStartPagePhoto,
          storage.resourceClosureEvidencePhoto,
          storage.resourceConditionPhotos,
          storage.resourceInstructionsPhoto,
        ],
      },
      resourceRead: {
        id: 'resourceRead',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      resourceAutocomplete: {
        id: 'resourceAutocomplete',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      keywordImport: {
        id: 'keywordImport',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      keywordCreate: {
        id: 'keywordCreate',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      keywordEdit: {
        id: 'keywordEdit',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      keywordDestroy: {
        id: 'keywordDestroy',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      keywordRead: {
        id: 'keywordRead',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      keywordAutocomplete: {
        id: 'keywordAutocomplete',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      formCategoryImport: {
        id: 'formCategoryImport',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      formCategoryCreate: {
        id: 'formCategoryCreate',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.formCategoryIcon],
      },
      formCategoryEdit: {
        id: 'formCategoryEdit',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.formCategoryIcon],
      },
      formCategoryDestroy: {
        id: 'formCategoryDestroy',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.formCategoryIcon],
      },
      formCategoryRead: {
        id: 'formCategoryRead',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      formCategoryAutocomplete: {
        id: 'formCategoryAutocomplete',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      assetImport: {
        id: 'assetImport',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      assetCreate: {
        id: 'assetCreate',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.assetIcon],
      },
      assetEdit: {
        id: 'assetEdit',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.assetIcon],
      },
      assetDestroy: {
        id: 'assetDestroy',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.assetIcon],
      },
      assetTemplateManage: {
        id: 'assetTemplateManage',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      assetRead: {
        id: 'assetRead',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      assetAutocomplete: {
        id: 'assetAutocomplete',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      notificationImport: {
        id: 'notificationImport',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      notificationCreate: {
        id: 'notificationCreate',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.notificationIcon],
      },
      notificationEdit: {
        id: 'notificationEdit',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.notificationIcon],
      },
      notificationDestroy: {
        id: 'notificationDestroy',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.notificationIcon],
      },
      notificationRead: {
        id: 'notificationRead',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      notificationAutocomplete: {
        id: 'notificationAutocomplete',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      formTemplateImport: {
        id: 'formTemplateImport',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      formTemplateCreate: {
        id: 'formTemplateCreate',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.formTemplatePreviewImage,
          storage.formTemplateIcon,
          storage.formTemplateInstructionsPhoto,
          storage.formTemplateStartPagePhoto,
          storage.formTemplateBuilder,
        ],
      },
      formTemplateEdit: {
        id: 'formTemplateEdit',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.formTemplatePreviewImage,
          storage.formTemplateIcon,
          storage.formTemplateInstructionsPhoto,
          storage.formTemplateStartPagePhoto,
          storage.formTemplateBuilder,
        ],
      },
      formTemplateDestroy: {
        id: 'formTemplateDestroy',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.formTemplatePreviewImage,
          storage.formTemplateIcon,
          storage.formTemplateInstructionsPhoto,
          storage.formTemplateStartPagePhoto,
          storage.formTemplateBuilder,
        ],
      },
      formTemplateRead: {
        id: 'formTemplateRead',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      formTemplateAutocomplete: {
        id: 'formTemplateAutocomplete',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      workflowImport: {
        id: 'workflowImport',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      workflowCreate: {
        id: 'workflowCreate',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.workflowIcon],
      },
      workflowEdit: {
        id: 'workflowEdit',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.workflowIcon],
      },
      workflowDestroy: {
        id: 'workflowDestroy',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.workflowIcon],
      },
      workflowRead: {
        id: 'workflowRead',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      workflowAutocomplete: {
        id: 'workflowAutocomplete',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      flowStepImport: {
        id: 'flowStepImport',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      flowStepCreate: {
        id: 'flowStepCreate',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      flowStepEdit: {
        id: 'flowStepEdit',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      flowStepDestroy: {
        id: 'flowStepDestroy',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      flowStepRead: {
        id: 'flowStepRead',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      flowStepAutocomplete: {
        id: 'flowStepAutocomplete',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      dataStudioImport: {
        id: 'dataStudioImport',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      dataStudioCreate: {
        id: 'dataStudioCreate',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      dataStudioEdit: {
        id: 'dataStudioEdit',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      dataStudioDestroy: {
        id: 'dataStudioDestroy',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      dataStudioRead: {
        id: 'dataStudioRead',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      dataStudioAutocomplete: {
        id: 'dataStudioAutocomplete',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      appUserImport: {
        id: 'appUserImport',
        allowedRoles: [
          roles.sub_admin,
          roles.admin,
          roles.supervisor,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      appUserCreate: {
        id: 'appUserCreate',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.appUserPhoto,
          storage.appUserSignature,
        ],
      },
      appUserEdit: {
        id: 'appUserEdit',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.appUserPhoto,
          storage.appUserSignature,
        ],
      },
      appUserDestroy: {
        id: 'appUserDestroy',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.appUserPhoto,
          storage.appUserSignature,
        ],
      },
      appUserTemplateManage: {
        id: 'appUserTemplateManage',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      appUserRead: {
        id: 'appUserRead',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      appUserAutocomplete: {
        id: 'appUserAutocomplete',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      apiKeyImport: {
        id: 'apiKeyImport',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      apiKeyCreate: {
        id: 'apiKeyCreate',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      apiKeyEdit: {
        id: 'apiKeyEdit',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      apiKeyDestroy: {
        id: 'apiKeyDestroy',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      apiKeyRead: {
        id: 'apiKeyRead',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      apiKeyAutocomplete: {
        id: 'apiKeyAutocomplete',
        allowedRoles: [roles.sub_admin, roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      indicatorImport: {
        id: 'indicatorImport',
        allowedRoles: [
          roles.admin,
          roles.sub_admin,
          roles.supervisor,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      indicatorCreate: {
        id: 'indicatorCreate',
        allowedRoles: [
          roles.admin,
          roles.sub_admin,
          roles.supervisor,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.indicatorAttachments],
      },
      indicatorEdit: {
        id: 'indicatorEdit',
        allowedRoles: [
          roles.admin,
          roles.sub_admin,
          roles.supervisor,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.indicatorAttachments],
      },
      indicatorDestroy: {
        id: 'indicatorDestroy',
        allowedRoles: [
          roles.admin,
          roles.sub_admin,
          roles.supervisor,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [storage.indicatorAttachments],
      },
      indicatorRead: {
        id: 'indicatorRead',
        allowedRoles: [
          roles.admin,
          roles.sub_admin,
          roles.supervisor,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      indicatorAutocomplete: {
        id: 'indicatorAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.sub_admin,
          roles.supervisor,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      // Workflow Launch permissions
      workflowLaunchImport: {
        id: 'workflowLaunchImport',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      workflowLaunchCreate: {
        id: 'workflowLaunchCreate',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      workflowLaunchEdit: {
        id: 'workflowLaunchEdit',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      workflowLaunchDestroy: {
        id: 'workflowLaunchDestroy',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      workflowLaunchRead: {
        id: 'workflowLaunchRead',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      workflowLaunchAutocomplete: {
        id: 'workflowLaunchAutocomplete',
        allowedRoles: [
          roles.supervisor,
          roles.sub_admin,
          roles.admin,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
    };
  }

  static get asArray() {
    return Object.keys(this.values).map((value) => {
      return this.values[value];
    });
  }
}

export default Permissions;
